/**
 *= require_self
 */

var page_error_box = {

    /**
     * The main error box of the page
     */
    $alert_box: $('#js-main-page-error-display'),

    /**
     * The UL of errors
     */
    $error_list: $('#js-main-page-error-list'),

    /**
     * How long the slide up/down animation lasts
     */
    slide_time: 400,

    /**
     * If is visible
     */
    visible: false,

    /**
     * The default error message
     */
    DEFAULT_ERROR: '',

    /**
     * Construcotr
     *
     * @author Blaž Pečnik <blaz@easistent.com>
     */
    init: function () {
        var obj = this;

        obj.DEFAULT_ERROR = [obj.$alert_box.data('default-error-msg')];

        obj.$alert_box.on('click', '.js-cacnel-errror-box', function () {
            obj.close();
        });
    },

    /**
     * Opens the alert box with the provided error messages,
     * this function is meant to substitute the default alert function
     *
     * @param  array errfields
     * @param  int   duration
     *
     * @author Blaž Pečnik <blaz@easistent.com>
     */
    alert: function (errfields, duration) {

        var obj = this;
        var error;

        /* Default duration 8s */
        duration = (typeof duration !== 'undefined') ? duration : false;

        /* Add the error fields */
        obj.$error_list.html('');
        for (error in errfields) {
            error = '<div>' + errfields[error] + '</div>';
            obj.$error_list.append(error);
        }

        obj.visible = true;

        /* Play animation, and close if only if duration is not false */
        obj.$alert_box.hide();
        obj.$alert_box.show(obj.slide_time, function() {
            if (duration !== false) {
                obj.$alert_box
                    .delay(duration)
                    .slideUp(obj.slide_time, function() {
                        obj.visible = false;
                    });
            }
        });
    },

    /**
     * Close the alert box
     *
     * @author Blaž Pečnik <blaz@easistent.com>
     */
    close: function () {
        var obj = this;

        obj.$alert_box.slideUp(obj.slide_time, function() {
            obj.visible = false;
        });
    }
};

page_error_box.init();